  import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
  selector: 'formly-input-phone',
  template: `
    <input matInput type="tel" mask="(000) 000-0000" [formControl]="formControl" [formlyAttributes]="field"/>
  `,
  styles: [
      'input { border: none; width: 100%; }',

  ]
})
export class FormlyInputPhoneTemplate extends FieldType {}
